module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#olympic",
      toString: function () {
        return this.url;
      }
    }